// F-MOTOR-RESERVAS.3.1.4 — data-testids do fluxo público de pré-reserva.
// Mantido isolado para facilitar testes E2E/RTL e refactoring sem acoplamento.

export const RESERVAR_TESTIDS = {
  shell: "reservar-shell",
  back: "reservar-back",
  stepIndicator: "reservar-step-indicator",

  // Step 1 — datas + hóspedes + café
  step1: "reservar-step-1",
  dateRange: "reservar-date-range",
  dateRangeTrigger: "reservar-date-range-trigger",
  guestsStepper: "reservar-guests-stepper",
  guestsMinus: "reservar-guests-minus",
  guestsPlus: "reservar-guests-plus",
  guestsValue: "reservar-guests-value",
  cafeSelect: "reservar-cafe-select",
  cafeSelectOption: (v) => `reservar-cafe-option-${v}`,
  verDisponibilidade: "reservar-ver-disponibilidade",
  step1Error: "reservar-step-1-error",

  // Step 2 — cotação + form hóspede
  step2: "reservar-step-2",
  cotacaoSummary: "reservar-cotacao-summary",
  cotacaoDiarias: "reservar-cotacao-diarias",
  cotacaoSubtotal: "reservar-cotacao-subtotal",
  cotacaoCafe: "reservar-cotacao-cafe",
  cotacaoTotal: "reservar-cotacao-total",
  cotacaoVoltar: "reservar-cotacao-voltar",
  hospedeNome: "reservar-hospede-nome",
  hospedeCpf: "reservar-hospede-cpf",
  hospedeEmail: "reservar-hospede-email",
  hospedeTelefone: "reservar-hospede-telefone",
  hospedeObservacoes: "reservar-hospede-observacoes",
  honeypot: "reservar-honeypot",
  aceiteCheckbox: "reservar-aceite",
  submit: "reservar-submit",
  submitLoading: "reservar-submit-loading",
  formError: "reservar-form-error",

  // Step 3 — sucesso
  step3: "reservar-step-3",
  sucessoTitulo: "reservar-sucesso-titulo",
  sucessoProtocolo: "reservar-sucesso-protocolo",
  sucessoTotal: "reservar-sucesso-total",
  sucessoNovaReserva: "reservar-sucesso-nova-reserva",
  sucessoWhatsapp: "reservar-sucesso-whatsapp",

  // Indisponível / erros
  unavailable: "reservar-unavailable",
  unavailableMotivo: "reservar-unavailable-motivo",
  unavailableWhatsapp: "reservar-unavailable-whatsapp",
  unavailableVoltar: "reservar-unavailable-voltar",
};
